import * as React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface IWorkoutSlider{
    workouts: JSX.Element[];
}

export const WorkoutSlider =(props: IWorkoutSlider)=>{
    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getResponsiveSettings = () => {
        const cardWidth = 250; // Based on WorkoutPreview.css card width
        const margin = 16; // Based on WorkoutListing.css margin-right
        const totalCardWidth = cardWidth + margin;
        const maxVisibleCards = Math.floor(screenWidth / totalCardWidth);
        
        if (screenWidth <= 800) {
            // Mobile: show 1-2 cards
            return {
                slidesToShow: Math.min(2, props.workouts.length),
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: false
            };
        } else if (screenWidth <= 1200) {
            // Tablet: show 3-4 cards
            return {
                slidesToShow: Math.min(4, props.workouts.length),
                slidesToScroll: 2,
                variableWidth: true,
                centerMode: false
            };
        } else {
            // Desktop: show as many as possible
            return {
                slidesToShow: Math.min(maxVisibleCards, props.workouts.length),
                slidesToScroll: Math.min(3, maxVisibleCards),
                variableWidth: true,
                centerMode: false
            };
        }
    };

    const responsiveSettings = getResponsiveSettings();
    
    const slickSettings = {
        className: "slider",
        dots: true,
        infinite: false,
        ...responsiveSettings,
        nextArrow: <NextArrow/>,
        prevArrow: <PrevArrow/>,
        adaptiveHeight: true,
        swipeToSlide: true,
        touchMove: true,
        accessibility: true,
        lazyLoad: 'ondemand' as const,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: Math.min(4, props.workouts.length),
                    slidesToScroll: 2,
                    variableWidth: true,
                    centerMode: false
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: Math.min(2, props.workouts.length),
                    slidesToScroll: 1,
                    variableWidth: true,
                    centerMode: false
                }
            }
        ]
    }
    
    return(
        <Slider {...slickSettings}>
            {props.workouts.map((workout, index) => 
                React.cloneElement(workout, { key: `workout-${index}` })
            )}
        </Slider>
    )
}

const NextArrow =(props) =>{
    const { className, style, onClick } = props;
    if(window.innerWidth > 800)
        return (
        <div
            className={className}
            style={{ ...style, display: "block"}}
            onClick={onClick}
        />
        );
    else
        return null;
}
  
const PrevArrow = (props)=> {
    const { className, style, onClick } = props;
    if (window.innerWidth > 800)
        return (
            <div
                className={className}
                style={{ ...style, display: "block" }}
                onClick={onClick}
            />
        );
    else
        return null;
}

